import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Field, isDirty, reduxForm } from 'redux-form';

import { Typography } from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';

import {
  DndUploadImage,
  FormActionButtons,
  CustomColorPicker,
  MultiSelect,
  Input
} from 'components';

import validate from './validate';
import useStyles from './styles';

const initialValues = {
  color: '',
  coverPhoto: {
    image: ''
  },
  languages: [],
  selectedUnitId: '',
  privacyPolicy: '',
  termsAndConditions: ''
};

const WidgetSettingsForm = ({ handleSubmit, colorHandler, color, isDirty }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const [openColorPicker, setOpenColorPicker] = React.useState(false);
  return (
    <div className={classes.formPanel}>
      <Typography className={classes.panelTitle}>
        {t('Widget settings')}
      </Typography>
      <form onSubmit={handleSubmit}>
        <div className={classes.inputFields}>
          <div className={classes.photoUpload}>
            <Field
              name="coverPhoto"
              label="Logotype"
              component={DndUploadImage}
              errorClass={classes.photoError}
              isDelete={true}
            />
          </div>
          <div className={classes.colorPaletteWrapper}>
            <Typography
              variant="h3"
              style={{
                marginBottom: '6px',
                textTransform: 'uppercase'
              }}
            >
              {t('Accent color')}
            </Typography>
            <div
              className={classes.colorPalette}
              style={{ backgroundColor: color }}
            >
              <div
                onClick={() => setOpenColorPicker(true)}
                className={classes.editIconWrapper}
              >
                <EditIcon className={classes.editIcon} />
              </div>
              {openColorPicker && (
                <Field
                  name="color"
                  onClose={setOpenColorPicker}
                  defaultColor={color}
                  onChange={colorHandler}
                  component={CustomColorPicker}
                />
              )}
            </div>
          </div>
        </div>
        <div className={classes.inputWrapper}>
          <Field
            name="privacyPolicy"
            className={classes.input}
            placeholder={t('Privacy Policy')}
            label={t('Privacy Policy') + ' *'}
            component={Input}
          />
          <Field
            name="termsAndConditions"
            className={classes.input}
            placeholder={t('Terms & Conditions')}
            label={t('Terms & Conditions') + ' *'}
            component={Input}
          />
        </div>

        <Field
          name="languages"
          list={['English', 'Norwegian']}
          component={MultiSelect}
        />

        <FormActionButtons
          isDisabledAction={!isDirty}
          cancelPath="/"
          actionLabel="Save"
        />
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  isDirty: isDirty('widgetForm')(state)
});

export default reduxForm({
  form: 'widgetForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  initialValues,
  validate
})(connect(mapStateToProps)(WidgetSettingsForm));
